/**
 * @description 获取热帖列表
 * @param { Object } params 请求参数 page: 当前页 size: 页数据大小 version: 当前版本号
 */
export const hotpostList = params => {
  return {
    url: '/api/topContent/list',
    method: 'get',
    params,
  };
};

/**
 * @description 获取关注列表
 * @param { Object } params 请求参数 loaded: 已加载数 timestamp: 结尾数据
 */
export const followList = params => {
  return {
    url: '/api/follow/home/v1',
    method: 'get',
    params,
  };
};

/**
 * @description 添加收藏
 * @param { Object } data 请求参数 refId: 内容id; source: 内容来源 dynamic(动态) article(文章)
 */
export const addFavorite = data => {
  return {
    url: '/api/favorite/v2',
    method: 'post',
    data,
  };
};

/**
 * @description 取消收藏
 * @param { Number } refId 内容id
 * @param { String } source 内容来源 dynamic(动态) article(文章)
 */
export const removeFavorite = (refId, source) => {
  return {
    url: `/api/favorite/${source}/${refId}/v2`,
    method: 'delete',
  };
};

/**
 * @description 点击分享按钮
 * @param { object } data 请求参数 source 内容来源 refId 内容id
 */
export const shareItem = data => {
  return {
    url: '/api/share/v1',
    method: 'post',
    data,
  };
};

export const GetHotTopicList = () => {
  return {
    url: '/api/hot/topic/list/v1',
    method: 'get',
  };
};
